import { ref, computed, isRef } from 'vue'

export const TOUR_STEPS = [
    {
        target: 'environment-picker',
        title: 'Switch environments',
        description:
            'Switch between environments (e.g., production, staging) to manage flags independently per environment.',
        placement: 'bottom',
    },
    {
        target: 'flags-nav',
        title: 'Your feature flags',
        description:
            "Your feature flags live here. We've created a few examples to get you started.",
        placement: 'right',
    },
    {
        target: 'create-flag',
        title: 'Create a flag',
        description:
            'Create your own flag here. Toggle it on or off to ship features safely.',
        placement: 'top',
    },
    {
        target: 'help-button',
        title: 'Get help anytime',
        description:
            "Stuck? Reach our support team anytime from here. We're happy to help.",
        placement: 'bottom',
    },
]

export function useProductTour(userUlidOrRef) {
    const userUlid = isRef(userUlidOrRef) ? userUlidOrRef : ref(userUlidOrRef)

    const storageKey = computed(() => `product-tour-done-${userUlid.value}`)

    const active = ref(false)
    const currentStep = ref(0)

    function isCompleted() {
        return localStorage.getItem(storageKey.value) === 'true'
    }

    function start(force = false) {
        if (!force && isCompleted()) return
        currentStep.value = 0
        active.value = true
    }

    function restart() {
        currentStep.value = 0
        active.value = true
    }

    function next() {
        if (currentStep.value < TOUR_STEPS.length - 1) {
            currentStep.value++
        } else {
            complete()
        }
    }

    function back() {
        if (currentStep.value > 0) {
            currentStep.value--
        }
    }

    function skip() {
        localStorage.setItem(storageKey.value, 'true')
        active.value = false
    }

    function complete() {
        localStorage.setItem(storageKey.value, 'true')
        active.value = false
    }

    return {
        active,
        currentStep,
        isCompleted,
        start,
        restart,
        next,
        back,
        skip,
        complete,
    }
}
